import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "LoginWithGoogle",
    meta: { layout: "login" },
    component: () => import("../views/LoginWithGoogle.vue"),
    beforeEnter(to, from, next) {
      if (store.state.u.api_token) {
        if (store.state.u.has_schedule) {
          next("/my-schedule");
        } else {
          next("/my-schedule");
          // next("/dashboard");
        }
      } else {
        next();
      }
    },
  },
  {
    path: "/course-details",
    name: "CourseDetails",
    meta: { auth: true },
    component: () => import("../views/CourseDetails.vue"),
  },
  {
    path: "/login-small",
    name: "LoginSmall",
    meta: { layout: "login" },
    component: () => import("../views/LoginWithGoogle.vue"),
  },

  {
    path: "/login",
    name: "login",
    meta: { layout: "login" },
    component: () => import("../views/Login.vue"),
  },

  {
    path: "/dashboard",
    name: "Dashboard",
    meta: { auth: true },
    component: () => import("../views/Dashboard.vue"),
  },

  {
    path: "/my-schedule",
    name: "MySchedule",
    meta: { auth: true },
    component: () => import("../views/MySchedule.vue"),
  },
  {
    path: "/lesson-plan-book",
    name: "LessonPlanBook",
    meta: { auth: true, for_teachers: true },
    component: () => import("../views/LessonPlanBook.vue"),
  },
  {
    path: "/gradebooks",
    name: "Gradebooks",
    meta: { auth: true },
    component: () => import("../views/Gradebooks.vue"),
  },
  {
    path: "/discipline",
    name: "Discipline",
    meta: { auth: true },
    component: () => import("../views/Discipline.vue"),
  },
  {
    path: "/attendance",
    name: "Attendance",
    meta: { auth: true },
    component: () => import("../views/Attendance.vue"),
  },
  {
    path: "/permissions",
    name: "Permissions",
    meta: { auth: true, for_system_admin: true },
    component: () => import("../views/Permissions.vue"),
  },
  {
    path: "/helpdesk",
    name: "Helpdesk",
    meta: { auth: true },
    component: () => import("../views/Helpdesk.vue"),
    beforeEnter(to, from, next) {
      if (store.state.u.api_token) {
        next();
      } else {
        // Login
        next("/");
      }
    },
  },
  {
    path: "/students",
    name: "Students",
    meta: { auth: true },
    component: () => import("../views/Students.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.for_system_admin) {
    if (store.state.u.type == 'System Admin') {
      next()
    } else {
      next("/my-schedule")
    }
  }
  else if (to.meta.for_teachers) {
    if (store.state.u.type != 'Student') {
      next()
    } else {
      next("/my-schedule")
    }
  }
  else {
    next()
  }
})



export default router;
